import { SET_RESPONSE_MODAL, RESET_RESPONSE_MODAL, CLICK_RESPONSE_MODAL } from '../constants/actionTypes';

export const setResponseModal = (payload) => ({ type: SET_RESPONSE_MODAL, payload });
export const resetResponseModal = (payload) => ({ type: RESET_RESPONSE_MODAL, payload });
export const clickResponseModal = (payload) => ({ type: CLICK_RESPONSE_MODAL, payload });
